export enum AccountTypeEnum {
  tvOwner = 'tv-owner',
  advertiser = 'advertizer'
}
